export const REQUEST = 'Admin/Respondents/REQUEST';
export const SUCCESS = 'Admin/Respondents/SUCCESS';
export const ERROR = 'Admin/Respondents/ERROR';

export const SET = 'Admin/Respondents/SET';
export const UPDATED = 'Admin/Respondents/UPDATED';
export const ADDED = 'Admin/Respondents/ADDED';
export const BAN_UPDATED = 'Admin/Respondents/BAN_UPDATED';